"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.triesRemaining = exports.isUserBlocked = exports.getErrorPayload = exports.getErrorMessage = void 0;
var lodash_camelcase_1 = __importDefault(require("lodash.camelcase"));
var lodash_get_1 = __importDefault(require("lodash.get"));
var enums_1 = require("../Common/utils/enums");
var getErrorCode = function (payload) {
    if (isGrpcEndpoint(payload)) {
        return payload.errorCode;
    }
    return payload.code;
};
// TODO: https://doordash.atlassian.net/browse/FR-1699
var isGrpcEndpoint = function (payload) { return payload && !!payload.errorCode; };
exports.getErrorMessage = function (error) {
    return lodash_get_1["default"](error, 'graphQLErrors[0].message') || '';
};
exports.getErrorPayload = function (isRestClient, error) {
    if (isRestClient) {
        return lodash_get_1["default"](error, 'networkError.result.errors[0]', {}) || {};
    }
    return lodash_get_1["default"](error, 'graphQLErrors[0].extensions.exception') || {};
};
exports.isUserBlocked = function (isRestClient, error) {
    var payload = exports.getErrorPayload(isRestClient, error);
    return getErrorCode(payload) === enums_1.ErrorCodes.TooManyAttempts;
};
exports.triesRemaining = function (isRestClient, error) {
    var payload = exports.getErrorPayload(isRestClient, error);
    var getRemainingVerificationAttempts = function () {
        if (isGrpcEndpoint(payload)) {
            var fieldsMap = lodash_get_1["default"](payload, 'details.fieldsMap');
            if (fieldsMap && fieldsMap.length) {
                var fieldsMapReduced = fieldsMap.reduce(function (pre, curr) {
                    if (curr.length > 1) {
                        var key = lodash_camelcase_1["default"](curr[0]);
                        pre[key] = curr[1];
                        return pre;
                    }
                }, {});
                return (fieldsMapReduced.verificationAttemptsRemaining &&
                    fieldsMapReduced.verificationAttemptsRemaining.numberValue);
            }
            return 0;
        }
        return lodash_get_1["default"](payload, 'detail.verification_attempts_remaining');
    };
    return getErrorCode(payload) === enums_1.ErrorCodes.InvalidCode
        ? getRemainingVerificationAttempts()
        : 0;
};
